import type { EditionSummary } from "@/types";

import PulseDatePicker from "./PulseDatePicker";

interface Props {
  editions: EditionSummary[];
  selectedDate: string;
}

export default function PulseHeaderActions({ editions, selectedDate }: Props) {
  return (
    <div className="pulse-header-actions">
      <PulseDatePicker editions={editions} selected={selectedDate} />
    </div>
  );
}
